module.exports = __webpack_public_path__ + "img/b_13.def574b0.jpg";